export const DEFAULT_GRADUATION_ACTIVITY_ID = 5;
export const CASHMERE_ACTIVITY_ID = 6;

export const LEGACY_ACTIVITY_ID_MAP = {
  3: DEFAULT_GRADUATION_ACTIVITY_ID,
  4: DEFAULT_GRADUATION_ACTIVITY_ID,
};

export const CONTEST_ACTIVITY_MAP = {
  "graduation-art": DEFAULT_GRADUATION_ACTIVITY_ID,
  "cashmere-design": CASHMERE_ACTIVITY_ID,
};

export const CONTEST_ACTIVITY_IDS = Object.values(CONTEST_ACTIVITY_MAP);

export function isNumericContestId(contestId) {
  return /^\d+$/.test(String(contestId || "").trim());
}

export function resolveContestActivityId(contestId) {
  if (isNumericContestId(contestId)) {
    const rawId = Number(contestId || 0);
    return LEGACY_ACTIVITY_ID_MAP[rawId] || rawId;
  }
  return CONTEST_ACTIVITY_MAP[String(contestId || "").trim()] || 0;
}

export function getContestKey(contestId) {
  const raw = String(contestId || "").trim();
  if (CONTEST_ACTIVITY_MAP[raw]) {
    return raw;
  }
  const activityId = resolveContestActivityId(raw);
  return Object.keys(CONTEST_ACTIVITY_MAP).find((key) => CONTEST_ACTIVITY_MAP[key] === activityId) || "graduation-art";
}
